export const BACKEND_VEHICLE_TYPE_ENUM = Object.freeze({
  VAN: 'VAN',
  TRUCK: 'TRUCK',
  SUV: 'SUV',
  CAR: 'CAR',
  MOTORCYCLE: 'MOTORCYCLE',
});

const UI_VEHICLE_TYPE_TO_API = {
  auto: BACKEND_VEHICLE_TYPE_ENUM.CAR,
  furgon: BACKEND_VEHICLE_TYPE_ENUM.VAN,
  moto: BACKEND_VEHICLE_TYPE_ENUM.MOTORCYCLE,
  suv: BACKEND_VEHICLE_TYPE_ENUM.SUV,
  camioneta: BACKEND_VEHICLE_TYPE_ENUM.TRUCK,

  carro: BACKEND_VEHICLE_TYPE_ENUM.CAR,
  furgao: BACKEND_VEHICLE_TYPE_ENUM.VAN,
};

export function mapVehicleTypeToApi(uiVehicleType) {
  if (!uiVehicleType) return '';
  const mapped = UI_VEHICLE_TYPE_TO_API[uiVehicleType];
  if (mapped) return mapped;
  return uiVehicleType;
}
